import React, { useContext, useCallback, useEffect } from "react";
import { Input, Button, Form, Select, Row, Col, DatePicker } from "antd";
import { useLocation } from "react-router-dom";
import { FiltersContext } from "@CONTEXTS";
import { Constants } from "@CONFIG";
import { SearchOutlined } from "@ant-design/icons";
import moment from "moment";
const { RangePicker } = DatePicker;

const VALID_INVOICE_TYPES = ["all", "unpaid", "overdue"];

const Filters = () => {
  const { dispatch } = useContext(FiltersContext);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const queryInvoiceType = query.get("invoiceType");
  const initialInvoiceType = VALID_INVOICE_TYPES.includes(queryInvoiceType)
    ? queryInvoiceType
    : "unpaid";
  const [form] = Form.useForm();
  const setFilters = useCallback(
    (obj) => {
      dispatch({
        type: "SET_FILTERS",
        payload: obj,
      });
    },
    [dispatch]
  );

  const onFinish = (values) => {
    const { invoiceType, search, createdDate, netDueDate } = values;

    const obj = {
      invoiceType,
      search,
      startCreatedDate: null,
      endCreatedDate: null,
      startNetDueDate: null,
      endNetDueDate: null,
    };

    if (createdDate) {
      obj.startCreatedDate = createdDate[0].format("YYYY-MM-DD");
      obj.endCreatedDate = createdDate[1].format("YYYY-MM-DD");
    }
    if (netDueDate) {
      obj.startNetDueDate = netDueDate[0].format("YYYY-MM-DD");
      obj.endNetDueDate = netDueDate[1].format("YYYY-MM-DD");
    }

    setFilters(obj);
  };

  useEffect(() => {
    form.setFieldsValue({ invoiceType: initialInvoiceType });
    resetFilters(initialInvoiceType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, location.search]);

  const resetFilters = (invoiceType) => {
    dispatch({
      type: "SET_FILTERS",
      payload: {
        invoiceType,
        search: null,
        createdDate: null,
        netDueDate: null,
      },
    });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      style={{ width: "100%" }}
      initialValues={{ invoiceType: initialInvoiceType }}
    >
      <Row wrap={false} style={{ width: "100%" }} gutter={16}>
        <Col span={4}>
          <Form.Item
            name="invoiceType"
            label="Fatura Tipi"
            style={{ marginBottom: 0 }}
          >
            <Select style={{ width: "100%" }}>
              <Select.Option value="all">Tüm Faturalarım</Select.Option>
              <Select.Option value="unpaid">
                Ödenmemiş Faturalarım
              </Select.Option>
              <Select.Option value="overdue">
                Vadesi Geçen Faturalarım
              </Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="search" style={{ marginBottom: 0 }} label="Arama">
            <Input
              placeholder="Belge numarası / açıklamaya göre ara"
              prefix={<SearchOutlined />}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name="createdDate"
            style={{ marginBottom: 0 }}
            label="Belge Kesim Tarihi"
          >
            <RangePicker
              style={{ width: "100%" }}
              format={Constants.FORMATS.dateFormat}
              placeholder={["Başlangıç Tarihi", "Bitiş Tarihi"]}
              ranges={{
                "Geçen Hafta": [
                  moment().subtract(1, "week").startOf("week"),
                  moment().subtract(1, "week").endOf("week"),
                ],
                "Geçen Ay": [
                  moment().subtract(1, "month").startOf("month"),
                  moment().subtract(1, "month").endOf("month"),
                ],
                "Geçen Yıl": [
                  moment().subtract(1, "year").startOf("year"),
                  moment().subtract(1, "year").endOf("year"),
                ],
                Bugün: [moment(), moment()],
                "Son 1 Hafta": [moment().subtract(6, "days"), moment()],
                "Son 1 Ay": [moment().subtract(29, "days"), moment()],
                "Bu Yıl": [moment().startOf("year"), moment().endOf("year")],
              }}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name="netDueDate"
            style={{ marginBottom: 0 }}
            label="Vade Tarihi"
          >
            <RangePicker
              style={{ width: "100%" }}
              format={Constants.FORMATS.dateFormat}
              placeholder={["Başlangıç Tarihi", "Bitiş Tarihi"]}
              ranges={{
                "Geçen Hafta": [
                  moment().subtract(1, "week").startOf("week"),
                  moment().subtract(1, "week").endOf("week"),
                ],
                "Geçen Ay": [
                  moment().subtract(1, "month").startOf("month"),
                  moment().subtract(1, "month").endOf("month"),
                ],
                "Geçen Yıl": [
                  moment().subtract(1, "year").startOf("year"),
                  moment().subtract(1, "year").endOf("year"),
                ],
                Bugün: [moment(), moment()],
                "Son 1 Hafta": [moment().subtract(6, "days"), moment()],
                "Son 1 Ay": [moment().subtract(29, "days"), moment()],
                "Bu Yıl": [moment().startOf("year"), moment().endOf("year")],
              }}
            />
          </Form.Item>
        </Col>
        <Col
          span={2}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <Form.Item style={{ width: "100%", marginBottom: 0 }}>
            <Button type="primary" block htmlType="submit">
              Ara
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default Filters;
